import { ADD_ROLE_VIDEO_INTERVIEW_QUESTIONS_AGENT_TASK } from "graphql/mutations";
import useMutateData, { MUTATION_TYPE } from "hooks/useMutateData";
import { useCallback } from "react";

export default function useRoleVideoInterviewQuestionsAgent() {
  const { handleAdd, loading } = useMutateData(
    {
      mutationName: {
        add: ADD_ROLE_VIDEO_INTERVIEW_QUESTIONS_AGENT_TASK,
      },
    },
    MUTATION_TYPE.add
  );

  
  const handleCreateAgentTask = useCallback(({ jobDescription, onCompleted, onError }) => {
    handleAdd({
      params: {
        jobDescription,
      },
      onCompleted,
      onError,
    });
  }, [handleAdd]);


  return { handleCreateAgentTask, loading };
};
